// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSocialWeibo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.594 4.116a5.295 5.295 0 0 1 5.04 1.63 5.271 5.271 0 0 1 1.175 4.951l-.068.231-.039.097a.765.765 0 0 1-1.414-.57 3.786 3.786 0 0 0-.788-3.682 3.767 3.767 0 0 0-3.583-1.159.767.767 0 0 1-.323-1.498zM4.982 9.267c2.518-2.518 5.459-3.665 6.559-2.56.488.487.535 1.33.224 2.337-.157.483.415.252.471.23l.005-.002c2.035-.853 3.812-.903 4.459.025.347.494.317 1.187-.006 1.991-.147.37.047.428.33.512 1.146.356 2.423 1.216 2.423 2.731 0 2.51-3.618 5.67-9.059 5.67C6.241 20.2 2 18.19 2 14.883c0-1.73 1.094-3.73 2.982-5.616zm11.024 5.22c-.212-2.174-3.071-3.67-6.383-3.343-3.311.328-5.823 2.355-5.605 4.528.217 2.174 3.07 3.67 6.382 3.343 3.312-.327 5.823-2.354 5.606-4.529zm-3.477 1.784c-.676 1.527-2.617 2.343-4.27 1.81-1.589-.513-2.265-2.085-1.565-3.5.682-1.389 2.465-2.174 4.041-1.764 1.63.422 2.459 1.96 1.794 3.454zm-3.37-1.165c-.512-.215-1.177.007-1.489.502-.323.498-.17 1.092.336 1.324.517.235 1.206.012 1.523-.5.312-.515.147-1.105-.37-1.326zm.853.183c.2.083.458-.012.57-.21.112-.2.041-.424-.159-.497-.194-.078-.44.017-.558.21-.112.195-.048.417.147.497zm9.146-5.199a.662.662 0 0 1-1.281-.31l.023-.096a1.258 1.258 0 0 0-.26-1.234 1.262 1.262 0 0 0-1.057-.408l-.142.021a.658.658 0 0 1-.782-.506.657.657 0 0 1 .505-.783 2.583 2.583 0 0 1 2.994 3.316z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSocialWeibo;
